import React, { useState, useEffect } from "react";
import "./Navbar.css";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";
import { useAuth } from "../../Pages/AuthContext";
import { Link } from "react-router-dom";
import gpaLogo from "../../assets/G2.png";
import Menuicon from "../../assets/menu.png";
import CloseIcon from "../../assets/close.png";
import { getStorage, ref, listAll } from "firebase/storage";

function Navbar() {
  const { isLoggedIn, userData } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [years, setYears] = useState([]);
  const [highlightActivities, setHighlightActivities] = useState(false);
  const storage = getStorage();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  // Function to handle gallery button click
  const handleGalleryButtonClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    // Open menu if in mobile view
    if (window.innerWidth <= 768) {
      setSidebarOpen(true);
    }

    // Highlight "Activities" menu
    setHighlightActivities(true);

    // Remove highlight after 3 seconds
    setTimeout(() => {
      setHighlightActivities(false);
    }, 3000);
  };

  useEffect(() => {
    const fetchYears = async () => {
      const storageRef = ref(storage, "ActivityPageData");
      const result = await listAll(storageRef);
      const yearFolders = result.prefixes.map((folder) => folder.name);
      setYears(yearFolders);
    };

    fetchYears();
  }, []);

  useEffect(() => {
    // Attach event listener to "GPCON Gallery" button
    const galleryButton = document.querySelector(".GallaryButton");
    if (galleryButton) {
      galleryButton.addEventListener("click", handleGalleryButtonClick);
    }

    return () => {
      if (galleryButton) {
        galleryButton.removeEventListener("click", handleGalleryButtonClick);
      }
    };
  }, []);

  return (
    <>
      {/* Top Bar */}
      <div className="top-bar">
        <div className="top-bar-left">
          <span>
            <i className="fa fa-envelope" style={{ marginRight: "5px" }}></i>{" "}
            gpaichalkaranji@gmail.com
          </span>
        </div>
        <div className="top-bar-right">
          <div className="social-icons">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
              <FaFacebookF />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
              <FaTwitter />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
              <FaLinkedinIn />
            </a>
          </div>
        </div>
      </div>

      {/* Main Navbar */}
      <div className="navbar-new">
        <div className="company-logo">
          <img
            src={gpaLogo}
            alt="GPA Ichalkaranji"
            className="logo"
            height={"120px"}
            draggable="false"
            onContextMenu={(e) => e.preventDefault()}
          />
        </div>

        {/* Menu button */}
        <div className="menu-btn" onClick={toggleSidebar}>
          <img src={Menuicon} alt="Menu" />
        </div>

        <ul className="menu-first">
          <li>
            <Link to="/" onClick={closeSidebar}>
              Home
            </Link>
          </li>

          {/* Activities Menu with Highlighting */}
          <li className={`menudropdown ${highlightActivities ? "highlighted" : ""}`}>
            <Link to="#">Gallery</Link>
            <ul className="menudropdown-content">
              {years.length > 0 ? (
                years.map((year) => (
                  <li key={year}>
                    <Link to={`/activities/${year}`}>{year}</Link>
                  </li>
                ))
              ) : (
                <li>Loading...</li>
              )}
            </ul>
          </li>

          <li>
            <Link to="/CommitteeMembers" onClick={closeSidebar}>
              Leadership Committee
            </Link>
          </li>
          <li>
            <Link to="/About" onClick={closeSidebar}>
              About Us
            </Link>
          </li>
          <li>
            <Link to="/Contact" onClick={closeSidebar}>
              Contact Us
            </Link>
          </li>
          <li>
            {isLoggedIn ? (
              <Link to="/profile" state={{ username: userData?.username }} onClick={closeSidebar}>
                Profile
              </Link>
            ) : (
              <Link className="login-btn" to="/login" onClick={closeSidebar}>
                Login
              </Link>
            )}
          </li>
        </ul>

        {/* Sidebar for Mobile */}
        <div className={`navbar-navigation-content ${sidebarOpen ? "open" : ""}`}>
          <button className="sidebar-close-btn" onClick={closeSidebar}>
            <img src={CloseIcon} alt="Close" />
          </button>
          <ul className="menu">
            <li>
              <Link to="/" onClick={closeSidebar}>
                Home
              </Link>
            </li>
            <li className={`dropdown ${highlightActivities ? "highlighted" : ""}`}>
              <Link to="#">Gallery</Link>
              <ul className="dropdown-content">
                {years.length > 0 ? (
                  years.map((year) => (
                    <li key={year}>
                      <Link to={`/activities/${year}`}>{year}</Link>
                    </li>
                  ))
                ) : (
                  <li>Loading...</li>
                )}
              </ul>
            </li>
            <li>
              <Link to="/CommitteeMembers" onClick={closeSidebar}>
                Leadership Committee
              </Link>
            </li>
            <li>
              <Link to="/About" onClick={closeSidebar}>
                About
              </Link>
            </li>
            <li>
              <Link to="/Contact" onClick={closeSidebar}>
                Contact
              </Link>
            </li>
            <li>
              {isLoggedIn ? (
                <Link to="/profile" state={{ username: userData?.username }} onClick={closeSidebar}>
                  Profile
                </Link>
              ) : (
                <Link className="login-btn" to="/login" onClick={closeSidebar}>
                  Login
                </Link>
              )}
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}

export default Navbar;
